import { toast } from "@/components/ui";
import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type {
  CarePlan,
  RequestGroup,
  ServiceRequest,
} from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";

interface RemoveTestFromOrderResponse {
  requestGroup: RequestGroup;
  serviceRequest: ServiceRequest;
  carePlan: CarePlan;
}

export const useRemoveTestFromOrder = ({
  patientId,
  encounterId,
  requestGroupId,
  serviceRequestId,
}: {
  patientId: string;
  encounterId: string;
  requestGroupId: string;
  serviceRequestId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<RemoveTestFromOrderResponse, void>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Labs.DELETE_TEST({
        patientId,
        encounterId,
        requestGroupId,
        serviceRequestId,
      }),
      mutationFn: () => {
        return axiosInstance.post(
          `/labs/order/${requestGroupId}/test/${serviceRequestId}/remove`,
        );
      },
      onError: () => {
        toast.error("Failed to remove test from order");
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Labs.DEFAULT({
            patientId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Labs.DEFAULT_V2({
            patientId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
